import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11 9h44v46H11V9z",
      stroke: "#1e3951",
      "stroke-width": "2",
      fill: "#fff",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13 12h40v41H13V12z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#86bc4d"
    }, null, -1),
    _createElementVNode("path", {
      d: "M42.5 12.5v40M31 21h22m-22 8h22m-22 8h22m-22 8h22M32.5 12.5v40M22 21h20m-20 8h20m-20 8h20m-20 8h20M22.5 12.5v40M13 21h20m-20 8h20m-20 8h20m-20 8h20",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "none"
    }, null, -1),
    _createElementVNode("path", {
      d: "M49.125 46.67H16.85l-.038 8.205-10.687-12.75 11-14v8.938l32 .517v9.09z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1)
  ])))
}
export default { render: render }